import { render, staticRenderFns } from "./CardCurrentPickup.vue?vue&type=template&id=433c687e&scoped=true"
import script from "./CardCurrentPickup.vue?vue&type=script&lang=js"
export * from "./CardCurrentPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433c687e",
  null
  
)

export default component.exports